<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { Card } from '@/components/ui/card';
import { cn } from '@/lib/utils';

const props = defineProps<{
    class?: HTMLAttributes['class'];
}>();
</script>

<template>
    <Card
        variant="default"
        :class="cn(
            'gap-0 rounded-2xl border-border/70 p-4',
            props.class,
        )"
    >
        <slot />
    </Card>
</template>
